import React from 'react'
import Chip from '@mui/material/Chip'

const BetaTag = () => {
  return (
    <Chip label='Beta' size='medium' sx={{ fontSize: '14px', backgroundColor: 'white', color: '#01A32D' }} />
  )
}

export default BetaTag
